import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { getRefreshParams } from '../../util/fieldLinkageUtils';
import SearchNav from './SearchNav';
import DataTable from '../../DataTable/DataTable';
import { ArrowItem, Page, Content, PopUp, Nav } from '@beisen/chaos-ui';
import * as helper from '../../util/helper';
import * as urlHelper from '../../util/url';
import ToolsBar from '../../ToolsBar/ToolsBar';
import ErrorPage from '../../ErrorPage/ErrorPage';
import transLoader from '@beisen/i18n-translation-loader';
import classNames from 'classNames';
import { addEnNavClassName } from '../../util/ui';
import ListLoad from '../../ListLoad/ListLoad';
import { formatSearchData } from '../../util/formatSearchData';

require('./LookUp.scss');

/**
 *
 *
 * @class LookUp
 * @extends {Component}
 * lookup字段,支持普通模式和高级模式
 * 在搜索表单中,lookup字段只支持普通模式不支持高级模式
 * 普通模式只需要根据条件查询lookup接口就能返回数据渲染表格
 * 高级模式是根据接口先拿到视图,在提取视图中的搜索表单的搜索数据请求tableList接口获取数据渲染表格
 */

const defaultTranslation = {
    clear: '清空'
    ,cancel: '取消'
    ,selectHolder: '点击选择'
    ,required: '必填'
};

class LookUp extends Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleTouchTap = this.handleTouchTap.bind(this);
        this.handleClearValue = this.handleClearValue.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.onChange = this.onChange.bind(this);
        this.afterClose = this.afterClose.bind(this);
        this.getContainerHeight = this.getContainerHeight.bind(this);
        this.reloadTable = this.reloadTable.bind(this);
        this.resetLookupFormData = this.resetLookupFormData.bind(this);
        this.getNavHeight = this.getNavHeight.bind(this);
        this.openPopup = this.openPopup.bind(this);
        this.storeAdvanceLookupTempData = this.storeAdvanceLookupTempData.bind(this);
        this.state = {
            showPopUp: false   //是否
            ,status: null
            ,visible: false
            ,isCancle: true
            ,tableFetching: true // tableList预加载标识,只在高级lookup上使用,普通lookup的tableList不会单独发送请求
            ,tableData: {} //普通lookup 接口返回的列表数据
            ,advanceLookUpDatas: { // 高级lookup 传递给toolsBar的相关props
                sortData: [],
                sortColumns: [],
                searchData: {},
                searchFormData: {},
                tableData: {}
            }
        };
        this.IndexData = {}; // 高级lookup接口返回的indexPage数据active_view
        this.defaultLookUpData;
         //是否高级搜索
        this.showAdvancedSearch = props.cmp_data.fieldschema && props.cmp_data.fieldschema === 'advanced';
        this.tableListViewName; // lookup内请求table的参数
        this.talbeMetaObjName;  // lookup内请求table的参数
        this.firstVisibleFieldName; // tableList中第一个可见字段
        this.pageNum = 0; // lookup搜索出的table 翻页的页数 默认是0
        this.searchValue = ''; // lookup搜索的关键字
        //this.initSearchForm; // 默认搜索条件
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            clear: 'common.clear',
            cancel: 'common.cancel',
            selectHolder: 'fieldPlaceHolder.selectHolder',
            required: 'common.required'
        }), props.translation);
    }

    componentWillMount() {
        if(this.props.pop_type == 'searchItem') {
            this.setState({ showPopUp: true });
        }
    }

    getMetaFieldPath(field) {
        if(!this.IndexData || !this.IndexData.sub_cmps.search_form || !this.IndexData.sub_cmps.search_form.sub_cmps) {
            return null;
        }
        const fieldCmp = this.IndexData.sub_cmps.search_form.sub_cmps.find(item => item.cmp_data && item.cmp_data.biz_data_key === field);
        if(fieldCmp && fieldCmp.cmp_data && fieldCmp.cmp_data.hasOwnProperty('metaFieldRelationIDPath')) {
            return fieldCmp.cmp_data.metaFieldRelationIDPath;
        }
        return null;
    }

    getSearchCondition(data) {
        let SearchForm  = this.IndexData.sub_cmps.search_form;
        if(data) {
            SearchForm = data.sub_cmps.search_form;
        }

        if(SearchForm) {
            let searchParams = {
                'metaObjName': SearchForm.cmp_data ? SearchForm.cmp_data.metaObjectName : '',
                'searchView': SearchForm.cmp_data ? SearchForm.cmp_data.viewName : '',
                'items': [],
                'searchFormFilterJson': SearchForm.cmp_data && SearchForm.cmp_data.filterJson || null
            };
            for(let key in SearchForm.biz_data) {
                const isInvalid  = !SearchForm.biz_data[key].text &&  !SearchForm.biz_data[key].value;
                if(!isInvalid) {
                    let searchItem = {
                        name: key,
                        text: SearchForm.biz_data[key].text,
                        value: SearchForm.biz_data[key].value,
                        num: SearchForm.biz_data[key].hasOwnProperty('num') ? SearchForm.biz_data[key].num : '',
                        metaFieldRelationIDPath: this.getMetaFieldPath(key),
                        metaObjName: ''
                    };
                    searchParams.items.push(searchItem);
                }
            }
            if(SearchForm.customview_biz_data) {
                SearchForm.customview_biz_data.map(item => {
                    searchParams.items.push(item);
                });
            }
            return searchParams;
        }
        return {};
    }

    componentDidMount() {
        if(this.props['form_state'] && this.props['form_state'] == 'show') {
            return false;
        }
        // 搜索表单 并且是快速筛选 并且不是高级lookup(搜索表单不支持高级lookup)
        if(this.props.formType && this.props.formType == 'searchForm'  && this.props.pop_type == 'searchItem' && !this.showAdvancedSearch) {
            this.searchData();
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.pop_type == 'searchItem' && nextProps.visible && !this.props.visible) {
            this.setState({ showPopUp: true },() => {
                this.searchData(); // 第一次搜索出无数据后 点击取消  再弹出lookup时不显示数据
            });
        }
    }

    componentWillUnmount() {
        if (helper.ifHidePopupNav() && this.props.pop_type !== 'searchList') {
            this.clearHeader();
        }
    }

    //组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
    getPreHeaderConfig() {
        helper.clearHeaderConfig();
    }

    //清除壳子回调函数
    clearCallback() {
        delete window.globalEventManager['lookupPageCancel'] && delete window.globalEventManager['lookupPageReset'];
    }

    getNavHeight() {
        if(this.navDom) {
            return this.navDom.offsetHeight;
        }
    }

    // 这里如果是高级lookup是没有searchNav的,这个时候获取的高度是否还正确?
    getContainerHeight() {
        return this.refs.lookupContent && ReactDOM.findDOMNode(this.refs.lookupContent).offsetHeight || 0;
    }

    sendAdvanceSearch(cbk) {
        const formState = this.props.cmp_data.cmp_state;
        const metaObjName = (this.props.cmp_data && this.props.cmp_data.metaObjectName)  || this.props.form_context.metaObjName;
        const params = {
            'search_Data': {
                'metaObjName': metaObjName,
                'items': [{
                    'name': this.props.cmp_data.field_name,
                    'text': '',
                    'value': '',
                    'metaObjName': metaObjName
                }]
            },
            refreshParams: this.props.getRefreshParams && this.props.getRefreshParams(this.props.cmp_data.refreshParams) || ''
        };
        const advancedUrl = this.props.cmp_data.advancedUrl;
        // 高级lookup接口的app是当前应用的名字
        let url = `${advancedUrl}${advancedUrl.indexOf('?') > -1 ? '&' : '?'}&app=${this.props.cmp_data.applicationName || helper.getCurrentApplicationName()}&formState=${formState}`;

        const fetchParam = {
            body: JSON.stringify(params),
            method: 'POST'
        };
        const successCallBack = function(response) {
            this.IndexData  = response.sub_cmps.active_view;
            const tableList = this.IndexData.sub_cmps.table_list;

            const search_data = this.getSearchCondition();
            let tempSearchData = {};
            for(let item of search_data.items) {
                tempSearchData[item.name] = item;
            }
            this.IndexData.sub_cmps.search_form.tempSearchData = tempSearchData;
            this.defaultLookUpData = JSON.parse(JSON.stringify(this.IndexData));
            const tableParams = {
                search_data: search_data,
                table_data: tableList.cmp_data,
                refreshParams: this.props.getRefreshParams && this.props.getRefreshParams(this.props.cmp_data.refreshParams) || ''
            };
            this.advanceSearchData({
                page: 0,
                params: tableParams,
                viewName: tableList.cmp_data.viewName,
                metaObjName: tableList.cmp_data.metaObjName,
                cbk: cbk
            });
        }.bind(this);

        const failureCallBack = function(error) {
            let tipInfo = { message: error.message, type: 'error' };
            if (error.isOffLine) {
                error['type'] = 'error';
                tipInfo = error;
            }
            this.props.actions.showTip(tipInfo);
        }.bind(this);
        url = helper.ajaxUrlCompletionInCachePage(url);
        window.CommonFetch && window.CommonFetch(url, fetchParam, successCallBack, failureCallBack);
    }

    openPopup(cb) {
        this.setState({ showPopUp: true, visible: true  },() => {
            if(this.showAdvancedSearch && helper.ifHidePopupNav() && this.props.pop_type !== 'searchList') {
                this.registCallback();
                this.setBoxHeader();
            }
            this.props.onFocus && this.props.onFocus();
            cb && cb();
        });
    }

    handleTouchTap(e) {
        e.preventDefault();
        if(this.showAdvancedSearch) {
            this.openPopup(this.sendAdvanceSearch.bind(this));
            // this.sendAdvanceSearch(this.openPopup); 2019-04-11 先弹popup再请求数据  解决点击字段由于接口慢  没有反应的问题
        } else {
            this.openPopup(this.searchData.bind(this));
            //this.searchData(undefined,undefined,this.openPopup);
        }
    }

    //设置壳子的导航对象并通知壳子更新导航
    setBoxHeader() {
        const { translation } = this;
        helper.generateHeaderConfig((headerConfig, setButton) => {
            let config = Object.assign({}, headerConfig);
            //设置左侧按钮
            const left_item = [
                {
                    callback: 'lookupPageCancel',
                    control: true,
                    text: '',
                    type: 'back'
                }
            ];
            config = setButton('left', left_item, config);

            //设置右侧按钮
            const right_item = [
                {
                    icon: '',
                    callback: 'lookupPageReset',
                    control: true,
                    text: translation.clear,
                    type: 'text'
                }
            ];
            config = setButton('right', right_item, config);
            //设置中间数据
            config.titleItem = {
                text: this.props.cmp_label,
                icon: '',
                callback: '',
                control: false
            };
            return config;
        });
    }

    //注册壳子回调函数，取消和清空
    registCallback() {
        window.globalEventManager['lookupPageCancel'] = this.cancelFn.bind(this);
        window.globalEventManager['lookupPageReset'] = this.handleClearValue;
    }

    cancelFn() {
        this.setState({ showPopUp: false }, () => {
            this.clearHeader();
        });
    }

    clearHeader() {
        if(this.showAdvancedSearch) {
            this.clearCallback();
            this.getPreHeaderConfig();
        }
    }

    handleSelect(e,item) {
        e.preventDefault();



        const advancedFieldName = this.props.cmp_data.refMetaObjectFieldName; //高级模式优先取refMetaObjectFieldName字段中的value
        const valueField = this.showAdvancedSearch ? item[advancedFieldName] : item['_rowData'];
        this.data = {
            text: item[this.firstVisibleFieldName] ? item[this.firstVisibleFieldName]['text'] : (item['_display'] ? item['_display']['text'] : ''),
            value: (valueField || item['_id'] || '').value || ''
        };

        // const refMetaObjectFieldName = this.props.cmp_data.refMetaObjectFieldName;
        // this.data = {
        //     text: item[this.firstVisibleFieldName] ? item[this.firstVisibleFieldName]['text'] : (item['_display'] ? item['_display']['text'] : ''),
        //     value: refMetaObjectFieldName && item[refMetaObjectFieldName] ? item[refMetaObjectFieldName].value : item['_id'].value
        // };

        if(this.props.pop_type == 'searchItem') {
            this.props.handleClosePopUp && this.props.handleClosePopUp();
            this.setState({ isCancle: false });
        }else {
            this.props.onChange && this.props.onChange(this.data);
            this.setState({ visible: false, isCancle: true }, () => {
                helper.ifHidePopupNav() && this.clearHeader();
            });
        }
    }

    handleClearValue() {
        this.data = { text: '',value: '' };
        if(this.props.pop_type == 'searchItem') {
            //搜索表单快速搜索模式,popup的显示与否由ToolsBar来控制
            this.props.handleClosePopUp && this.props.handleClosePopUp();
            this.setState({ isCancle: false });
        }else {
            this.setState({ visible: false, isCancle: true,showPopUp: false },() => {
                if(this.showAdvancedSearch && helper.ifHidePopupNav()) {
                    this.clearHeader();
                }
            });
            this.props.onChange && this.props.onChange({ text: '',value: '' });
        }
    }

    afterClose() {
        if(!this.state.isCancle) {
            this.props.onChange && this.props.onChange(this.data);
            this.props.synBizData && this.props.synBizData();
        }
        this.setState({ showPopUp: false });
    }

    handleCancel(e) {
        e && e.preventDefault();
        if(this.props.pop_type == 'searchItem') {
            this.props.handleCancel && this.props.handleCancel();
        }
        this.setState({ visible: false, isCancle: true, showPopUp: false });
    }

    getSearchParams() {
        let param = {
            'search_data':
                { 'metaObjName': (this.props.cmp_data && this.props.cmp_data.metaObjectName)  || this.props.form_context.metaObjName,
                    'items': [
                    {
                        'name': this.props.cmp_data && this.props.cmp_data.field_name,
                        'text': '',
                        'value': '',
                        'metaObjName': (this.props.cmp_data && this.props.cmp_data.metaObjectName)  || this.props.form_context.metaObjName
                    }]
                },
            'table_data': {
                'paging': {
                    'total': 0,
                    'capacity': 15,
                    'page': 0,
                    'capacityList': [15, 30, 60, 100]
                }
            },
            'metaObjName': (this.props.cmp_data && this.props.cmp_data.metaObjectName)  || this.props.form_context.metaObjName
        };

        if(this.props.form_context.id) {
            param.id = this.props.form_context.id;
        }

        if(this.props.form_context.parentMetaObjName && this.props.form_context.parentDataId) {
            param.parentMetaObjName = this.props.form_context.parentMetaObjName;
            param.parentDataId = this.props.form_context.parentDataId;
        }
        return param;
    }

    // 普通lookup 搜索框的值发生变化的时候搜索
    onChange(event) {
        let inVal = event.currentTarget.value;
        this.searchData(inVal);
    }

    // 列表加载更多
    loadMore() {
        const tableParams = {
            search_data: this.state.advanceLookUpDatas.searchData,
            table_data: this.state.advanceLookUpDatas.tableData
        };

        this.showAdvancedSearch ? this.advanceSearchData({ page: this.pageNum + 1,params: tableParams, loadType: 'loadMore',cbk: () => {
            //2019-04-10 待优化
            this.refs.table && this.refs.table.updateLoadedPageRange(this.IndexData.sub_cmps.table_list);
        } }) : this.searchData(this.searchValue, this.pageNum + 1);
    }

    convertBizDataToKeyValue() {
        const bizData = this.props.form_context.bizData;
        let kv = {};
        for(let prop in bizData) {
            kv[prop] = (bizData[prop] && bizData[prop].value) || '';
        }
        return kv;
    }

    // 高级lookup搜索行为
    advanceSearchData(params) {
        this.IndexData.sub_cmps.table_list.cmp_data.paging.page = params.page || 0;
        this.tableListViewName = params.viewName ? params.viewName : this.tableListViewName;
        this.talbeMetaObjName = params.metaObjName ? params.metaObjName : this.talbeMetaObjName;

        // tableList接口需要考虑跨应用的问题
        // 根据字段的cmp_data中的refMetaObjectName属性判断
        // 该属性的格式为 appName.indexName  即应用名.视图名
        // 需要兼容老数据,如果不存在该属性(refMetaObjectName)则默认取当前应用的名称
        const app = this.props.cmp_data.refMetaObjectName ? this.props.cmp_data.refMetaObjectName.match(/(\w+).*/)[1] : helper.getCurrentApplicationName();
        let url = `/api/v2/UI/TableList?viewName=${this.tableListViewName}&metaObjName=${this.talbeMetaObjName}&app=${app}&isLookUpRequest=true&localApp=${helper.getCurrentApplicationName()}`;
        const postParam = {
            refreshParams: this.props.getRefreshParams && this.props.getRefreshParams(this.props.cmp_data.refreshParams) || '',
            table_data: params.params.table_data,
            search_data: params.params.search_data
        };

        if(params.params && params.params.search_data) {
            postParam['search_data'] = formatSearchData(postParam.search_data);
        }

        const fetchParam = {
            body: JSON.stringify(postParam),
            method: 'POST'
        };
        const successCallBack = function(response) {
            if(params.loadType == 'loadMore') {
                const tableData = this.IndexData.sub_cmps.table_list;
                const new_biz_data = tableData['biz_data'].concat(response.biz_data);
                const new_rows = tableData['rows'] ? tableData['rows'].concat(response.rows || []) : [];
                this.IndexData.sub_cmps.table_list['biz_data'] = new_biz_data;
                this.IndexData.sub_cmps.table_list['rows'] = new_rows;
            }else {
                this.IndexData.sub_cmps.table_list = response;
            }

            let bizData = {};
            for(let item of params.params.search_data.items) {
                bizData[item.name] = item;
            }
            this.IndexData.sub_cmps.search_form.biz_data = bizData;
            this.IndexData.sub_cmps.search_form.tempSearchData = bizData;

            const sortData = this.IndexData.sub_cmps.table_list.cmp_data.sort_fields || [];
            const sortColumns = [];
            this.IndexData.sub_cmps.table_list.sub_cmps.map(cmp => {
                if(cmp.cmp_data.sortable) {
                    sortColumns.push(cmp.cmp_data);
                }
            });

            this.setState({
                tableFetching: false,
                tableData: this.IndexData.sub_cmps.table_list,
                advanceLookUpDatas: {
                    sortData: sortData,
                    searchData: this.getSearchCondition(),
                    searchFormData: this.IndexData.sub_cmps.search_form,
                    sortColumns: sortColumns,
                    tableData: this.IndexData.sub_cmps.table_list.cmp_data || {}
                }
            },() => {
                this.pageNum = this.IndexData.sub_cmps.table_list.cmp_data.paging.page;
                params.cbk && params.cbk();
            });
        }.bind(this);

        const failureCallBack = function(error) {
            let tipInfo = { message: error.message, type: 'error' };
            if (error.isOffLine) {
                error['type'] = 'error';
                tipInfo = error;
            }
            this.props.actions.showTip(tipInfo);
        }.bind(this);
        url = helper.ajaxUrlCompletionInCachePage(url);
        window.CommonFetch && window.CommonFetch(url, fetchParam, successCallBack, failureCallBack);
    }

    // 普通lookup搜索行为
    searchData(value = '', pageNum = 0, cbk = undefined) {
        let params = {
            'id': this.props.form_context.id,
            'metaObjName': (this.props.cmp_data && this.props.cmp_data.metaObjectName)  || this.props.form_context.metaObjName,
            'parentMetaObjName': this.props.form_context.parentMetaObjName,
            'parentDataId': this.props.form_context.parentDataId,
            'search_data':
                { 'metaObjName': (this.props.cmp_data && this.props.cmp_data.metaObjectName)  || this.props.form_context.metaObjName,
                    'items': [
                    {
                        'name': this.props.cmp_data && this.props.cmp_data.field_name,
                        'text': '',
                        'value': value || '',
                        'metaObjName': (this.props.cmp_data && this.props.cmp_data.metaObjectName)  || this.props.form_context.metaObjName,
                        'metaFieldRelationIDPath': this.props.cmp_data && this.props.cmp_data.metaFieldRelationIDPath
                    }]
                },
            'table_data': {
                'paging': {
                    'total': 0,
                    'capacity': 15,
                    'page': pageNum || 0,
                    'capacityList': [15, 30, 60, 100]
                }
            },
            refreshParams: this.props.getRefreshParams && this.props.getRefreshParams(this.props.cmp_data.refreshParams) || ''
        };

        const defaultParams = {
            app: helper.getCurrentApplicationName(), //普通lookup接口的app永远是当前应用的名字,即使是跨应用查询,由后端做处理
            formState: this.props.cmp_data.cmp_state,
            parentDataId: params.parentDataId
        };
        let fetchUrl = urlHelper.formatUrl(this.props.cmp_data.url,this.props.form_context.queryUrl,this.props.form_context.cmpContext,this.convertBizDataToKeyValue(), {},defaultParams);
        const successCallBack = function(response) {
            let tableData = JSON.parse(JSON.stringify(this.state.tableData));
            if(response.cmp_data && response.cmp_data.paging && response.cmp_data.paging.page != 0) {
                // 翻页(加载更多) biz_data进行追加、cmp_data 进行替换
                tableData.biz_data = tableData.biz_data.concat(response.biz_data);
                tableData.cmp_data = response.cmp_data;
            }else{
                tableData = response;
            }
            this.setState({ tableData: tableData },() => {
                this.pageNum = pageNum;
                this.searchValue = value;
                cbk && cbk();
            });
        }.bind(this);

        const failureCallBack = function(error) {
            let tipInfo = { message: error.message, type: 'error' };
            if (error.isOffLine) {
                error['type'] = 'error';
                tipInfo = error;
            }
            if(error.code == '403') {
                this.setState({ status: 'noPermission',showPopUp: true,visible: true });
            }else{
                this.props.actions.showTip(tipInfo);
            }
        }.bind(this);

        fetchUrl = helper.ajaxUrlCompletionInCachePage(fetchUrl);
        window.CommonFetch && window.CommonFetch(fetchUrl, { body: JSON.stringify(params),method: 'POST' }, successCallBack, failureCallBack);
    }

    storeAdvanceLookupTempData(data) {
        const converData = {};
        for(let obj of data) {
            converData[obj.name] = obj;
        }
        Object.assign(this.IndexData.sub_cmps.search_form,{ biz_data: converData,tempSearchData: converData });
        const sortColumns = [];
        this.IndexData.sub_cmps.table_list.sub_cmps.map(cmp => {
            if(cmp.cmp_data.sortable) {
                sortColumns.push(cmp.cmp_data);
            }
        });
        this.setState({
            advanceLookUpDatas: {
                sortData: this.IndexData.sub_cmps.table_list.cmp_data.sort_fields || [],
                searchData: this.getSearchCondition(),
                searchFormData: this.IndexData.sub_cmps.search_form,
                sortColumns: sortColumns,
                tableData: this.IndexData.sub_cmps.table_list.cmp_data || {}
            }
        });
    }
    /**
    * lookup高级表单重置功能
    */
    resetLookupFormData() {
        const sortColumns = [];
        this.defaultLookUpData.sub_cmps.table_list.sub_cmps.map(cmp => {
            if(cmp.cmp_data.sortable) {
                sortColumns.push(cmp.cmp_data);
            }
        });
        this.setState({
            advanceLookUpDatas: {
                sortData: this.defaultLookUpData.sub_cmps.table_list.cmp_data.sort_fields || [],
                searchData: this.getSearchCondition(this.defaultLookUpData),
                searchFormData: this.defaultLookUpData.sub_cmps.search_form,
                sortColumns: sortColumns,
                tableData: this.defaultLookUpData.sub_cmps.table_list.cmp_data || {}
            }
        });
        //this.IndexData.sub_cmps.table_list.cmp_data.paging.page = 0;
        // const data = Object.assign({ searchData: this.getSearchCondition() }, this.state.advanceLookUpDatas.sortColumns.length > 0 ? { sortData: this.IndexData.sub_cmps.table_list.cmp_data.sort_fields } : {});
        // this.reloadTable(data);
    }

    reloadTable(data) {
        let toolsBarSource = {};
        if(data.hasOwnProperty('sortData') && data.sortData) {
            const sortColumn = Object.assign({}, this.state.advanceLookUpDatas.sortColumns[0], { ascActive: data.sortData.sort_dir === 'asc', descActive: data.sortData.sort_dir === 'desc' });
            toolsBarSource = Object.assign({},this.state.advanceLookUpDatas,{ sortData: data.sortData }, { sortColumns: [sortColumn] });
            this.sortColumns = toolsBarSource.sortColumns;
            this.sortData = toolsBarSource.sortData;
            this.IndexData.sub_cmps.table_list.cmp_data.sort_fields = this.sortData;
        }
        if(data.hasOwnProperty('searchData')) {
            let searchDataToolsBar = Object.assign({},this.state.advanceLookUpDatas.searchData);
            const searchData = data.searchData.items || data.searchData;
            searchDataToolsBar.items = searchData;
            let biz_data = {};
            searchData.forEach(data => {
                biz_data[data.name] = data;
            });
            const searchFormData = Object.assign({}, this.state.advanceLookUpDatas.searchFormData);
            searchFormData.biz_data = biz_data;
            searchFormData.tempSearchData = biz_data;
            toolsBarSource = Object.assign({},this.state.advanceLookUpDatas,toolsBarSource,{ searchData: searchDataToolsBar, searchFormData });
            this.searchDatas = toolsBarSource.searchData;
            this.searchFormData = toolsBarSource.searchFormData;
        }
        this.setState({ tableFetching: true,advanceLookUpDatas: toolsBarSource },() => {
            const tableParams = {
                search_data: this.state.advanceLookUpDatas.searchData,
                table_data: this.state.advanceLookUpDatas.tableData
            };
            this.advanceSearchData({ page: 0, params: tableParams });
        });
    }

  	renderPanel() {
        const { translation } = this;
        const style = this.props.pop_type == 'searchList' ? { width: '85%', left: '15%' } : {};
        const visible = this.props.pop_type == 'searchItem' ? this.props.visible : this.state.visible;
        const animation = this.props.pop_type == 'searchList' ? 'right-slide-fade' : 'bottom-slide-fade';
        const tableList = this.state.tableData || {};
        if(tableList && tableList.sub_cmps) {
            const firstField = tableList.sub_cmps.find(sub => {
                return sub.cmp_data.visible;
            });
            if(firstField) {
                this.firstVisibleFieldName =   firstField.cmp_name;
            }
        }
        const errorInfo = { errorType: 'inner_401' };
        const enNavButtonClass = addEnNavClassName();
        return (
            <PopUp visible={visible}
                   animation={animation}
                   maskAnimation="fade"
                   cls='lookup_popup'
                   style={style}
                   onClose={this.handleCancel}
                   afterClose={this.afterClose}
                   lazyRender={true}
            >
                <Page ref="lookupPage" cls='lookup-page'>
                    {
                        this.showAdvancedSearch && !helper.ifHidePopupNav() ?
                        <Nav navRef={navDom => this.navDom = navDom} cls='editform-navbar lookup' title={this.props.cmp_label}>
                            <a role='left' href='javascript:;'
                            className={classNames('editform-clear-btn', enNavButtonClass)}
                            onTouchTap={this.handleClearValue}>
                            {translation.clear}
                            </a>
                            <a role='right' href='javascript:;'
                            className={classNames('editform-cancle-btn', enNavButtonClass)}
                            onTouchTap={() => this.setState({ showPopUp: false })}>
                            {translation.cancel}
                            </a>
                        </Nav> : null
                    }

                    {
                        this.showAdvancedSearch ?
                        <ToolsBar   sortData={this.state.advanceLookUpDatas.sortData}
                                    sortColumns={this.state.advanceLookUpDatas.sortColumns}
                                    searchData={this.state.advanceLookUpDatas.searchData}
                                    searchFormData={this.state.advanceLookUpDatas.searchFormData}
                                    tableData={this.state.advanceLookUpDatas.tableData.cmp_data}
                                    actions={this.props.actions}
                                    reloadTable={this.reloadTable}
                                    isLookupAdvanced={true}
                                    resetLookupFormData={this.resetLookupFormData}
                                    storeAdvanceLookupTempData={this.storeAdvanceLookupTempData}
                                    getNavHeight={this.getNavHeight}
                                    />
                        :
                        <SearchNav onChange={this.onChange} cancelFn={this.handleCancel} onClearValue={this.handleClearValue} pop_type={this.props.pop_type} translation={this.translation} />
                    }
                    <Content ref="lookupContent">
                        {this.state.status == 'noPermission' ?
                            <ErrorPage errorType='outer_403' /> :
                              !tableList.sub_cmps ? <ListLoad /> :
                                <DataTable {...tableList}
                                       ref='table'
                                       actions={this.props.actions}
                                       searchData={this.state.advanceLookUpDatas.searchData}
                                       noBottomButton={true}
                                       num={1}
                                       isFetching={this.showAdvancedSearch ? this.state.tableFetching : false}
                                       showAdvancedSearch={this.showAdvancedSearch}
                                       loadData={this.showAdvancedSearch}
                                       loadMore={this.loadMore}
                                       isNoShowRowButton={true}
                                       disableRemberPosition={true}
                                       onTableItemClick={this.handleSelect}
                                />
                            }
                    </Content>
                </Page>
            </PopUp>
        );
  	}

    renderNormalLookUp() {
        const errMsg = this.props.errorMessage && this.props.errorMessage.message;
        return (
            <span>
                <ArrowItem
                    label={this.props.label}
                    type='text'
                    required={this.props.required}
                    errorMsg={errMsg}
                    onClickForm={this.handleTouchTap}
                    value={(!this.props.text && this.props.value) ? '---' : this.props.text}
                    isReadOnly={this.props.isReadOnly}
                    desc={this.props.desc}
                    translation={this.translation}
                    styleTitle={this.props.styleTitle}
                />
                {this.props.children}
                {this.state.showPopUp ? this.renderPanel() : null}
            </span>
        );
    }

    renderSearchItemLookUp() {
        return this.state.showPopUp ? this.renderPanel() : null;
    }

    render() {
        return this.props.pop_type == 'searchItem' ? this.renderSearchItemLookUp() :
               this.renderNormalLookUp();
    }
}

LookUp.defaultProps = {
    cmp_data: {
        datasource: []
    }
};

export default LookUp;



// WEBPACK FOOTER //
// ./src/components/Field_Components/LookUp/LookUp.js